export const fontNoto = '"Noto Sans Arabic", sans-serif'

export const fontNoto15 = {
  fontFamily: fontNoto,
  fontSize: 15
}
export const fontNoto14 = {
  fontFamily: fontNoto,
  fontSize: 14
}